var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetterA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 880,
    height: 916,
    viewBox: "0 0 880 916",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M292.183 164.65L442.798 139.993L491.183 810.232L312.687 819.955L292.183 164.65Z",
    fill: "#2B1B57",
    fillOpacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M442.731 140.091L497.007 93.3739L850.716 563.052L756.312 617.556L670.078 556.383L612.922 599.05L627.506 717.19L491.195 810.391L442.731 140.091Z",
    fill: "url(#paint0_linear_9_68)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M674.707 549.858L669.958 546.489L665.292 549.972L608.136 592.639L604.413 595.419L604.982 600.03L618.97 713.336L498.171 795.93L451.001 143.528L495.754 105.008L838.888 560.643L756.755 608.062L674.707 549.858Z",
    stroke: "#2B1B57",
    strokeOpacity: 0.95,
    strokeWidth: 16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M577.051 447.658C575.991 440.487 584.253 435.717 589.934 440.22L633.198 474.512C637.624 478.02 637.119 484.886 632.228 487.709L597.03 508.031C592.139 510.855 585.941 507.859 585.116 502.272L577.051 447.658Z",
    fill: "#2B1B57",
    fillOpacity: 0.95
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M385.89 109.188L496.411 93.2789L442.731 140.091L292.213 164.591L385.89 109.188Z",
    fill: "#54B0F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M330.268 150.798L388.429 116.4L472.337 104.322L439.414 133.032L330.268 150.798Z",
    stroke: "#2B1B57",
    strokeOpacity: 0.95,
    strokeWidth: 15
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M670.078 556.383L756.216 617.391L688.033 612.813L643.544 576.097L670.078 556.383Z",
    fill: "#2B1B57",
    fillOpacity: 0.95
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_68",
    x1: 370.542,
    y1: 166.389,
    x2: 679.566,
    y2: 701.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54B0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E719A1",
    stopOpacity: 0.38
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterA);
export default __webpack_public_path__ + "static/media/letterA.ed27d0b934498a0602e2c3ae4dacb408.svg";
export { ForwardRef as ReactComponent };